<template>
  <div class="pa-0 mt-3 commerce-section">
        <div v-if="crmLoading" class="pa-3 d-flex justify-center">Loading...</div>
        <div v-else class="panel-height mt-5">
          <v-row no-gutters class="d-flex justify-center mb-4">
            <v-col v-if="crms.length>1 && crms.includes('neto')" :class="{ 'active-platform': selectedPlatform === 'neto' }" class="d-flex justify-center selector-image" cols="3">
              <v-sheet @click="fetchOrders('neto')" class="pa-1 ma-1">
                <v-img :width="60" src="@/assets/img/neto.svg" />
              </v-sheet>
            </v-col>
            <v-divider v-if="crms.length>1 && crms.includes('neto')" thickness="1" length="20" class="px-1" vertical/>
            <v-col v-if="crms.length>1 && crms.includes('shopify')" :class="{ 'active-platform': selectedPlatform === 'shopify' }" class="d-flex justify-center selector-image ml-3" cols="3">
              <v-sheet @click="fetchOrders('shopify')" class="pa-1 ma-1">
                <v-img :width="85" src="@/assets/img/Shopify.svg" />
              </v-sheet>
            </v-col>
            <v-divider v-if="crms.length>2" thickness="1" length="20" class="px-1" vertical/>
            <v-col v-if="crms.length>1 && crms.includes('retail_express')"  :class="{ 'active-platform': selectedPlatform === 'retail_express' }" class="d-flex justify-center selector-image ml-3" cols="3">
              <v-sheet @click="fetchOrders('retail_express')" class="pa-1 ma-1">
                <v-img src="@/assets/img/retail_express.svg" />
              </v-sheet>
            </v-col>  
          </v-row>
            <div class="mb-4">
              <v-text-field
              class="body-1"
              v-model="searchOrder"
              placeholder="Search"
              outlined
              required
              dense
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              :loading="searchOrder ? isLoading : false"
              @click.native.stop
              @click:clear="clearSearch()"
              @input="filterOrderIds"
              /> 
            </div>
          <div class="pb-1 pl-1 datatable-container pr-1" @scroll="handleScroll">
            <v-data-table
              :fixed-header="true"
              :headers="orderHeaders"
              :items="orderIds"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              item-key="id"
              show-expand
              :loading="isLoading"
              class="elevation-1 orders-list"
              hide-default-footer
              @click:row="toggleExpand"
              @item-expanded="fetchOrderDetails"
              :items-per-page="-1"
              :item-class="rowClass"
            >
            <template #item.shopName="{item}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ item.shopName.length > 12 ? item.shopName.substring(0, 12) + '...' : item.shopName }}
                  </span>
                </template>
                <span>{{ item.shopName }}</span>
              </v-tooltip>
            </template>
            <template #item.date="{item}">
              <span> {{ item.date | formatDay }}</span>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-0 order-expanded">
                <div class="pa-2 detail-panel-wrapper">
                  <div v-if="itemLoading" class="d-flex justify-center">Loading...</div>
                  <div v-else-if="orderDetails">
                    <div class="pb-2">
                      <span class="font-size-16 font-weight-bold">Order Details</span>
                      <a 
                        :href="generateURL()"
                        target="_blank"
                        class="text-decoration-none"
                      >
                        <span class="text-caption ml-2">View in Store</span>
                        <v-icon color="info" small> mdi-open-in-new </v-icon>
                      </a>
                    </div>
                    <v-row class="expanded-inner-header ma-0 pa-0">
                      <v-col cols="7" class="font-weight-bold pa-1 body-2">Order Items (SKU)</v-col>
                      <v-col cols="2" class="font-weight-bold pa-1 body-2">Qty</v-col>
                      <v-col cols="3" class="font-weight-bold pa-1 body-2">Price</v-col>
                    </v-row>
                    <v-row v-for="item, id in orderDetails.order_items" :key="id" class="order-line-item ma-0 pa-0">
                      <v-col cols="7" class="pa-1 body-1">{{ item.product.name }} ({{ item.product.item_id }})</v-col>
                      <v-col cols="2" class="pa-1 body-1">{{ item.quantity }}</v-col>
                      <v-col cols="3" class="pa-1 body-1">${{ item.price }}</v-col>
                    </v-row>
                    <v-divider class="mt-5 mb-6"></v-divider>
                    <v-row class="ma-0 pa-0">
                      <v-col class="pa-1">
                        <span> Total: {{ orderDetails.grand_total ? '$' + orderDetails.grand_total  : '-' }}</span>
                      </v-col>
                      <v-col class="pa-1">
                        <span>
                          Status: 
                          <v-chip
                            :color="getStatusColor(orderDetails.order_status)"
                            :text-color="getStatusColor(orderDetails.order_status)"
                            outlined
                            size="small"
                            small
                            class="ml-1"
                          >
                            {{ orderDetails.order_status }}
                          </v-chip>
                        </span>  
                      </v-col>
                    </v-row>
                    <v-divider class="my-3"></v-divider>
                    <v-card class="my-3" v-if="selectedPlatform === 'neto'">
                      <v-expansion-panels flat v-model="notesPanel" multiple>
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            expand-icon="mdi-chevron-down"
                            class="font-weight-600 px-3"
                          >
                            <div
                              class="d-flex flex-row body-1 font-weight-600 align-center"
                            >
                              <span class="secondary--font"> Sticky Notes</span>
                              <div v-if="!notesLoading && notesCount > 0" class="secondary--font note-counter align-center font-weight-bold px-2 ml-1">
                                {{ notesCount}}
                              </div>
                            </div>
                            <v-row class="d-flex flex-row-reverse mr-1">
                              <v-btn
                                text
                                class="body-2 font-weight-600"
                                v-track="'toggle-addnote-dialog'"
                                @click.stop="toggleAddNoteDialog"
                              >
                                <span class="secondary--font"> + New </span>
                              </v-btn>
                            </v-row> 
                          </v-expansion-panel-header>
                          <v-divider></v-divider>
                          <v-expansion-panel-content v-if="!notesLoading && stickyNotes.length > 0" class="notes-panel my-3 overflow-auto">
                            <div
                              v-for="(note, index) in stickyNotes"
                              :key="index"
                              class="notes-color py-2 mb-2"
                            >
                              <p class="ml-2 body-1 d-flex">
                                <span class="secondary--font font-weight-600">
                                  {{ note.title | upperCaseFirst }}
                                </span>
                              </p>
                              <v-tooltip bottom max-width="250">
                                <template v-slot:activator="{ on, attrs }">
                                  <span class="ml-2 mr-2 word-break text-ellipsis body-1"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ note.content | upperCaseFirst }}
                                  </span>
                                </template>
                                <span class="body-1">
                                  {{ note.content | upperCaseFirst }}
                                </span>
                              </v-tooltip>
                            </div>
                          </v-expansion-panel-content>
                          <v-expansion-panel-content v-else> 
                            <div class="pa-3 d-flex justify-center">{{ notesLoading ? 'Loading...' : 'No Data Found'}}</div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card>
                  </div>
                </div>
              </td>
            </template>
          </v-data-table>
          </div>
        </div>
    <!-- Save note dialog box -->
    <AddStickyNoteDialog 
      ref="refAddNoteDialog"
      :addNoteDialog="addNoteDialog"
      @onSaveNote="saveNote"
      @toggleAddNoteDialog="toggleAddNoteDialog"
      :saveLoader="saveLoader"
    />
  </div>
</template>
<script>
import { $orders, $connector } from "@/services/Index";
import AddStickyNoteDialog from "@/components/commerce/AddStickyNoteDialog.vue";
import constants from '@core/config/constants'

export default {
  props: {
    contactEmail: {
      type: String
    }
  },
  components: {
    AddStickyNoteDialog
  },
  data() {
    return {
      addNoteDialog: false,
      stickyNotes: [],
      notesCount: 0,
      rightSidePanel: [0, 1],
      notesPanel: [1, 1],
      isLoading: false,
      expanded: [],
      singleExpand: true,
      orderHeaders: [
        {
          text: 'Order ID',
          sortable: false,
          value: 'orderId',
          width: '28%'
        },
        { text: 'Store', value: 'shopName', sortable: false, width: '40%' },
        { text: 'Order Date', value: 'date', sortable: false, width: '30%' },
        { text: '', value: 'data-table-expand', width: '2%' }
      ],
      selectedPlatform: '',
      orderIds: [],
      orderId: null,
      orderDetails: null,
      orderError: '',
      page: 1,
      perPage: 10,
      enableScroll: true,
      itemLoading: false,
      crms: [],
      crmLoading: true,
      searchOrder:"",
      notesLoading: false,
      saveLoader: false,
      searchOrder:"",
      loadOrders: false,
      constants: constants,
    };
  },
 
  mounted(){
    this.checkOrdersData()
  },

  methods: {
    getStatusColor(status) {
      let constantOrderStatus = this.constants.ORDER_STATUS
      if(constantOrderStatus[status.toLowerCase()]) {
        return constantOrderStatus[status.toLowerCase()].color
      } else {
        return constantOrderStatus['default'].color
      }
    },
    toggleAddNoteDialog() {
      this.addNoteDialog = !this.addNoteDialog;
      this.$refs.refAddNoteDialog.resetValidation()
      this.$refs.refAddNoteDialog.reset()
    },
    saveNote(title, description) {
      let selectedOrder = this.expanded[0]
      let payload = {
                      neto_domain: selectedOrder.store,
                      Order: [
                          {
                              StickyNoteTitle: title,
                              StickyNote: description,
                              OrderID: selectedOrder.orderId
                          }
                      ]
                  }
      this.saveLoader = true
      $connector.addStickyNote(payload, {}).then(res => {
        this.saveLoader = false
        this.addNoteDialog = !this.addNoteDialog;
        this.$store.dispatch("ui/snackbar", [
              {
                message: `Sticky Note added successfully`,
                type: "success",
              },
            ]);
        this.getStickyNotes(selectedOrder.store, selectedOrder.orderId)
      }).catch((err) => {
        this.saveLoader = false
        this.addNoteDialog = !this.addNoteDialog;
        this.$store.dispatch("ui/snackbar", [
              {
                message: `Please try again`,
                type: "error",
              },
            ]);
      })
    },
    getStickyNotes(storeDomain, orderId) {
      let payload = { neto_domain: storeDomain, order_id: orderId }
      this.notesLoading = true
      $connector.getStickyNotes(this.selectedPlatform, payload).then(res => {
        this.notesCount = res.data.result_info.total_count
        const stickyNotesData = res.data.result
        stickyNotesData.sort((a, b ) => new Date(b.date_created) - new Date(a.date_created))
        this.notesLoading = false
        if(stickyNotesData.length > 0) {
          this.stickyNotes = stickyNotesData
        } else {
          this.stickyNotes = []
        }
      }).catch((err) => {
        this.notesLoading = false
      })
    },
    async checkOrdersData() {
      try {
        this.orderIds = [];
        let netoOrders, shopifyOrders, rexOrders
        this.crms = [];
        let payload = {
          page: 1,
          per_page: 10,
          email: this.contactEmail,
          source: 'neto',
          active: true
        };

        const fetchOrders = async (source) => {
          payload.source = source;
          const response = await $orders.fetch({ params: payload });
          return response.data.data.orders;
        };

        netoOrders = await fetchOrders('neto');
        if (netoOrders.length > 0) {
          this.crms.push('neto');
          this.selectedPlatform = 'neto';
          this.orderIds = netoOrders.map(order => ({
            orderId: order.original_order_id,
            date: order.order_date,
            shopName: order.shop_name,
            store: order.source_name,
            id: order.id
          }));
        }

        shopifyOrders = await fetchOrders('shopify');
        if (shopifyOrders.length > 0) {
          this.crms.push('shopify');
          if (netoOrders.length === 0) {
            this.selectedPlatform = 'shopify';
            this.orderIds = shopifyOrders.map(order => ({
              orderId: order.original_order_id,
              date: order.order_date,
              shopName: order.shop_name,
              store: order.source_name,
              id: order.id
            }));
          }
        }

        rexOrders = await fetchOrders('retail_express');
        if (rexOrders.length > 0) {
          this.crms.push('retail_express');
          if (netoOrders.length === 0 && shopifyOrders.length === 0) {
            this.selectedPlatform = 'retail_express';
            this.orderIds = rexOrders.map(order => ({
              orderId: order.original_order_id,
              date: order.order_date,
              shopName: order.shop_name,
              store: order.source_name,
              id: order.id
            }));
          }
        }
        this.crmLoading = false;
      } catch (error) {
        this.crmLoading = false;
      }
    },
    toggleExpand(item, event) {
      this.expanded = []
      if(event.isExpanded) {
        const indexExpanded = this.expanded.findIndex(i => i === item);
        this.expanded.splice(indexExpanded, 1)
      } else {
        this.fetchOrderDetails(item);
        this.expanded.push(item);
      }
    },
    handleScroll(event) {
      const bottomReached =
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight - 10
      if (!this.loadOrders && bottomReached && this.enableScroll) {
        this.getMoreOrderIds()
      }
    },
    generateURL() {
      if(this.orderDetails && this.selectedPlatform === 'neto') {
        return `https://${this.orderDetails.source_name}/_cpanel/order/vieworder?id=${this.orderDetails.original_order_id}`
      } else if(this.orderDetails && this.selectedPlatform === 'retail_express') {
        //redirect to store for retail express orders
        return `${this.orderDetails.source_name}/DOTNET/Admin/Reports/ReportSales.aspx?OrderNumber=${this.orderDetails.original_order_id}&considerfilters=1`

      } else {
        const store = this.orderDetails.source_name.split('.')[0]
        return `https://admin.shopify.com/store/${store}/orders`
      }
    },
    getMoreOrderIds() {
      ++this.page
      this.loadOrders = true
      let payload = {
        page: this.page,
        per_page: this.perPage,
        email: this.contactEmail,
        source: this.selectedPlatform,
        ...(this.searchOrder && { org_order_id : this.searchOrder }),
        active: true
      }
      $orders.fetch({params: payload}).then((response) => {
        this.loadOrders = false
        let ordersData = response.data.data.orders
        let ordersLength = ordersData.length
        if (ordersLength === 0) {
          this.enableScroll = false
        } else {
          this.enableScroll = true
          let moreOrderIds = ordersData.map((order) => {
            return {
              orderId: order.original_order_id,
              date: order.order_date,
              shopName: order.shop_name,
              store: order.source_name,
              id: order.id
            }
          });
          this.orderIds.push(...moreOrderIds)
        }  
      }).catch((err) => {
        this.loadOrders = false
      })
    },
    fetchOrders(selection) {
      this.selectedPlatform = selection;
      this.fetchOrderIds();
    },
    fetchOrderIds() {
      this.page = 1
      this.orderIds = []
      let payload = {
        page: this.page,
        per_page: this.perPage,
        email: this.contactEmail,
        source: this.selectedPlatform,
        ...(this.searchOrder &&{ org_order_id : this.searchOrder }),
        active: true
      }
      this.isLoading = true
      $orders.fetch({params: payload}).then((response) => {
        this.isLoading = false
        let ordersData = response.data.data.orders
        if(ordersData.length > 0) {
          this.orderIds = ordersData.map((order) => {
            return {
              orderId: order.original_order_id,
              date: order.order_date,
              shopName: order.shop_name,
              store: order.source_name,
              id: order.id
            }
          })
        }
        else{
          this.orderIds = [];
        }
      }).catch((error) => {
        this.isLoading = false
        if(Object.keys(error.response).length > 0) {
          this.orderError = 'Order info not available'
        }
      })
    },
    fetchOrderDetails(item) {
      //adding check as item is in differenet formats
      const selectedItem = 'item' in item ? item.item : item
      //prevent fetching same order details again
      if(this.orderId !== selectedItem.id) {
        this.itemLoading = true
        this.orderDetails = null
        this.orderId = selectedItem.id
        $orders.show(this.orderId).then((response) => {
          this.orderDetails = response.data.data.order
          //fetch order notes only in case of neto
          if(this.selectedPlatform === 'neto')
            this.getStickyNotes(selectedItem.store, selectedItem.orderId)
          this.itemLoading = false
        }).catch((err) => {
          this.itemLoading = false
        })
      }
    },
    filterOrderIds(){
      if(this.searchOrder ) {
        this.fetchOrderIds()
      }
    },
    clearSearch(){
      this.searchOrder="";
      this.fetchOrderIds()
    },
    rowClass(item) {
      let rowClass = 'order-row'
      return rowClass;
    }
  },
};
</script>
<style lang="scss">
.orders-list tbody tr:nth-of-type(even) {
   background-color: rgb(239, 244, 248);
}
.order-line-item:nth-of-type(odd) {
  background-color: rgba(209, 237, 255, 1);
}
.v-expansion-panel-content__wrap {
  padding: 0px 12px 16px !important;
}
.datatable-container {
  overflow-y: auto;
}

.orders-list th,
.orders-list td {
  padding: 4px!important;
}
.orders-list th:first-child,
.orders-list td:first-child {
  padding-left: 10px!important;
}
.orders-list td.order-expanded {
  padding-left: 0px!important;
}
.theme--light.v-data-table.orders-list > .v-data-table__wrapper > table > thead > tr > th {
  color: rgba(0, 0, 0, 0.87) !important;
  background-color: rgb(239, 244, 248);
  font-family: "Montserrat" !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}
.order-row {
  cursor: pointer;
}
tr.v-data-table__expanded__row td {
  font-weight: bold !important;
}
.detail-panel-wrapper {
  background-color: #EFFAFF;
}
.expanded-inner-header{
  color: rgba(0, 0, 0, 0.6)
}
.font-size-16 {
  font-size: 16px;
}
.active-platform 
{
  border-bottom: 3px solid rgba(0, 107, 175, 1);
}
.selector-image:hover {
  cursor: pointer;
}
.width-200{
  width: 200px;
}  
.notes-panel {
  max-height: 210px !important;
}
.notes-color {
  background-color: #fef2cc;
  border-left: 6px solid #f8c045;
  border-radius: 8px 0px 0px 8px;
} 
.note-counter{
  background-color: #727272;
  border-radius: 11px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 14px !important;
}

.commerce-section .v-sheet{
 background-color: transparent !important;
 border-color: transparent !important;
}
</style>
